// extracted by mini-css-extract-plugin
module.exports = {"resultsLoading__header":"ResultsLoading_resultsLoading__header__Y9Vvk","resultsLoading__sort":"ResultsLoading_resultsLoading__sort__dsUVH"};